export enum WdataEvent {
    INSTALL,
    UPGRADE,
    DOWNGRADE
}
